
const initial_state = {
  origin: {
    marker: '',
    label: null
  },
  destination: {
    marker: '',
    label: null
  },
  selectedPath: 0,
  flyTo: false
};

const directions = (state = initial_state, action) => {
  const returnedState = Object.assign({}, state);
  switch (action.type) {
    case 'DIRECTIONS_SET_ORIGIN':
      returnedState.origin.marker = action.marker;
      returnedState.origin.label = action.label;
      return returnedState;
    case 'DIRECTIONS_LABEL_ORIGIN':
      returnedState.origin.label = action.label;
      return returnedState;
    case 'DIRECTIONS_LABEL_DESTINATION':
      returnedState.destination.label = action.label;
      return returnedState;
    case 'DIRECTIONS_SET_DESTINATION':
      returnedState.destination.marker = action.marker;
      returnedState.destination.label = action.label;
      return returnedState;
    case 'DIRECTIONS_SET_SELECTED':
      returnedState.selectedPath = action.pathID;
      return returnedState;
    case 'ENABLE_FLY_TO_PATH':
      returnedState.flyTo = true;
      return returnedState;
    case 'DISABLE_FLY_TO_PATH':
      returnedState.flyTo = false;
      return returnedState;
    default:
      return state;
  }
};

export default directions;
